import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { CompanyContext } from '../../../Context/CompanyContext.js';
import style from "./addOrderCashAdmin.module.css"



export default function AddOrderCashAdmin({ getOrder, getData }) {
   const [loading, setLoading] = useState(false);
   const [values, setValues] = useState({});
   const [listTest, setListTest] = useState([]);
   const [listTestName, setListTestName] = useState([]);
   const [search, setSearch] = useState([]);
   const [error, setError] = useState("");

   const { getAllCompanyInfo, allCompanyInfo } = useContext(CompanyContext);
   const closeBtnRef = useRef();
   const testInputRef = useRef();
   const companyInputRef = useRef();

   const patient_NameRef = useRef();
   const patient_PhoneRef = useRef();
   const genderRef = useRef();
   const birthDayRef = useRef();

   const token = localStorage.getItem("token");
   const header = useMemo(() => ({
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${token}`,
   }), [token]);


   //& Get All test And Search On Test By Test Name :
   async function createCashOrderByAdmin() {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/order/createCashOrderByAdmin`, { ...values }, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               closeBtnRef.current.click();
               testInputRef.current.value = "";
               companyInputRef.current.value = "";
               patient_NameRef.current.value = "";
               patient_PhoneRef.current.value = "";
               birthDayRef.current.value = "";
               genderRef.current.value = "";
               setValues({});
               setListTest([]);
               setListTestName([]);
               setSearch([]);
               setLoading(false);
               getData();
               getOrder();
            }
         })
         .catch((error) => {
            setError(error.response.data.message)
            setLoading(false);
         })
   }





   //^=============================================
   function handleAddCompany(e) {
      setValues((prev) => ({ ...prev, companyId: e.target.value }));
   }
   //^=============================================






   //^=============================================
   //& Search Test By Test Name :
   function searchInput(e) {
      if (e.target.value === "") {
         setSearch([])
      }
      if (e.target.value.length >= 3) {
         getSearchData((e.target.value).toLowerCase())
      }
   }
   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`)
         .then(({ data }) => {
            if (data.message === "success") {
               setSearch(data.tests)
            }
         })
         .catch((error) => {
            console.log(error.response.data.message)
         })
   }
   //& Search Test By Test Name :
   function addTestToList(id, name) {
      if (listTest.find((ele) => ele === id)) {
         return;
      }
      setValues(prev => ({ ...prev, listIdTest: [...(prev.listIdTest || []), id] }));
      setListTest([...listTest, id])
      setListTestName([...listTestName, { id, name }])
      setSearch([])
   }
   const deleteTest = (test) => {
      setValues(prev => ({ ...prev, listIdTest: prev.listIdTest.filter(id => id !== test.id) }));
      setListTestName(prevTest => prevTest.filter(ele => ele.name !== test.name));
   };
   //^=============================================


   useEffect(() => {
      getAllCompanyInfo()
   }, [])
   return (
      <Fragment>
         <div className='container'>
            <div dir='rtl' className="modal fade" id="AddOrderCashAdmin" tabIndex="-1" aria-labelledby="AddOrderCashAdminLabel" aria-hidden="true">
               <div className="modal-dialog">
                  <div className="modal-content">

                     <div className="d-flex justify-content-between align-items-center p-3">
                        <h5 dir='rtl' className="modal-title" id="AddOrderCashAdminLabel">أضافة طلب كاش جديد</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>

                     <div className="modal-body">
                        <div className="my-2">
                           <form >
                              <div className="my-2">
                                 <label htmlFor="patient_Name" className="form-label">اسم المريض</label>
                                 <input ref={patient_NameRef} type="text" onChange={(e) => { setValues((prev) => ({ ...prev, patient_Name: e.target.value })) }} className='form-control' id='patient_Name' placeholder='الاسم' />
                              </div>
                              <div className="my-2">
                                 <label htmlFor="patient_Phone" className="form-label">رقم تليفون المريض</label>
                                 <input ref={patient_PhoneRef} type="text" onChange={(e) => { setValues((prev) => ({ ...prev, patient_Phone: e.target.value })) }} className='form-control' id='patient_Phone' placeholder='رقم التليفون' />
                              </div>
                              <div className="my-2">
                                 <label htmlFor="birthDay" className="form-label">تاريخ ميلاد المريض</label>
                                 <input ref={birthDayRef} type="date" onChange={(e) => { setValues((prev) => ({ ...prev, birthDay: e.target.value })) }} className='form-control' id='birthDay' placeholder='تاريخ الميلاد' />
                              </div>


                              <div className="my-2">
                                 <label htmlFor="gender" className="form-label">الجنس</label>
                                 <select ref={genderRef} id="gender" className="form-control" onChange={(e) => { setValues((prev) => ({ ...prev, gender: e.target.value })) }}>
                                    <option value="">الجنس</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                 </select>
                              </div>
                           </form>
                        </div>

                        <div className="my-2">
                           <label htmlFor="company" className="form-label">اختار مقدم الخدمة</label>
                           <select ref={companyInputRef} name="company" id="company" className="form-control" onChange={(e) => { handleAddCompany(e) }}>
                              <option value="">اختيار مقدم الخدمة</option>
                              {allCompanyInfo.length > 0 ?
                                 allCompanyInfo.map((ele) =>
                                    <option value={ele._id}>{ele.name}</option>
                                 )
                                 :
                                 ""
                              }
                           </select>
                        </div>

                        <div className='my-2'>
                           <form >
                              <label htmlFor="test" className="form-label">اختار  الخدمات </label>
                              <input ref={testInputRef} type="search" onChange={(e) => { searchInput(e) }} className='form-control' id='test' placeholder='أضافة  خدمات ' name="search" />
                           </form>

                           {search.length ?
                              <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                 {search.map((ele) => <p key={ele._id} onClick={() => addTestToList(ele._id, ele.name)} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success cursor'>{ele.name}</p>)}
                              </div>
                              : ""
                           }


                           <div className='container'>
                              {listTestName.map((ele) =>
                                 <div key={ele.name} className='bg-body-secondary rounded-3'>
                                    <div className='d-flex justify-content-between px-2 my-1  bg-body-tertiary rounded-3'>
                                       <i onClick={() => { deleteTest(ele) }} className="fa-solid fa-trash text-danger btn"></i>
                                       <p className='text-center p-0 m-0'>{ele.name}</p>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className=''>
                           {loading ?
                              <button className='btn bg-main btn-sm m-2'> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <>
                                 <button className='btn btn-new-color btn-sm m-2' onClick={() => { createCashOrderByAdmin() }}>اتمام الطلب</button>
                                 {error ? <p className='text-danger d-inline-block'>{error}</p> : ""}
                              </>
                           }

                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
